export const remotes = {
  backend: 'https://api.tk-luch.ru/api',
  username: '6b0f7e19-7ed0-4ed8-8455-922ba8aab4dd',
  password: '2CWyT5pCWrMdoX',
}

export const organithation = {
  url: 'https://suggestions.dadata.ru/suggestions/api/',
  token: '7678a7f3618dcc2e2dff9268960a196e0e9bb990',
}

export const address = {
  url: 'https://suggestions.dadata.ru/suggestions/api/',
  token: '7678a7f3618dcc2e2dff9268960a196e0e9bb990',
}

export const fio = {
  url: 'https://suggestions.dadata.ru/suggestions/api/',
  token: '7678a7f3618dcc2e2dff9268960a196e0e9bb990',
}

export const cities = {
  url: 'https://b2b.otr-it.ru/api/public/cities',
}

export const matrixBackend = {
  url: 'https://matrix.otr-it.ru'
}

export const b2bBackend = {
  url: 'https://b2b.otr-it.ru',
}

